<div [attr.data-id]="tour.id"
     [attr.data-hotel-id]="tour.hotelId"
     [attr.data-operator]="'1'"
     class="tour-card js-show-hotel-info-data data-angular">

    <div class="tour-card__photo showHotelInfo">
        <app-tour-image [tour]="tour"></app-tour-image>
    </div>

    <div class="tour-card__body">
        <div class="tour-card__top">
            <div class="tour-card__ratings">
                <app-hotel-stars [value]="tour.stars || tour.hotelClass"></app-hotel-stars>
                <app-hotel-rating *ngIf="tour.rating"
                                  [rating]="tour.rating"
                                  [reviewsCount]="tour.bookingReviewsCount"
                                  type="booking"></app-hotel-rating>
            </div>

            <div class="tour-card__wishlist" *ngIf="isWishlist">
                <app-hotel-wishlist [tour]="tour" [wishlistHotels]="wishlistHotels"/>
            </div>
        </div>

        <div class="tour-card__main">
            <div class="tour-card__info">
                <div class="tour-card__name showHotelInfo"
                     data-target-tab="tabPhoto"
                     data-target-scroll="gallery-with-previews"
                     (click)="openTourView()">
                    {{ hotelName }}
                    <span *ngIf="tour.isCombined">({{ messages.combiTour }})</span>
                </div>
                <div class="tour-card__region">{{ tour.country }}, {{ tour.region }}</div>
            </div>
        </div>

        <div class="tour-card__actions">
            <div class="tour-card__price">{{ tour.price.value | priceFormat:tour.price.currency }}</div>
            <div class="tour-card__cashback">кешбэк {{ cashback | priceFormat:tour.price.currency }}</div>
            <button type="button"
                    class="tour-card__select showHotelInfo"
                    (click)="openTourView()">
                Выбрать
            </button>
        </div>

        <app-hotel-services [tour]="tour"></app-hotel-services>
    </div>

    <a #viewLink
       [attr.href]="viewHref"
       target="_blank"
       class="tour-card__view-link"
       (click)="tourViewClick()">
        <span class="sr-only">{{ messages.moreDetails }}</span>
    </a>
</div>
